import { useNavigate } from "react-router-dom";
import { buildClasses } from "../utils/buildClasses";
import { WebsiteButton } from "./WebsiteButton";

// A page's sign-up call to action. On phones the web app doesn't work well and
// there's no mobile app yet, so below the md breakpoint visitors get a note
// instead of a button that leads somewhere they'd have a bad time.
//
// Switched in CSS, not by detecting the device in React, so the prerendered HTML
// is already right before the app loads and hydration sees identical markup at
// every width. Spans throughout, so it can sit inside inline wrappers like the
// hero's load-in Reveal. The header hides its Log in and Sign up buttons at the
// same breakpoint; keep the two in step.
export function SignUpAction(props: {
  label: string;
  arrow?: boolean;
  // Off where the page already says it further down, like the landing page's
  // hero, so phones see the note once.
  mobileNote?: boolean;
}): JSX.Element {
  const navigate = useNavigate();

  return (
    <>
      <span className={buildClasses("hidden", "md:inline-flex")}>
        <WebsiteButton
          size="lg"
          arrow={props.arrow}
          onClick={() => navigate("/auth/signup")}
        >
          {props.label}
        </WebsiteButton>
      </span>
      {props.mobileNote !== false && <MobileComingSoon />}
    </>
  );
}

function MobileComingSoon(): JSX.Element {
  return (
    <span
      className={buildClasses(
        "mx-auto",
        "block",
        "max-w-xs",
        "text-balance",
        "text-center",
        "text-lg",
        "font-light",
        "leading-relaxed",
        "text-on-surface-600",
        "md:hidden",
      )}
    >
      Our mobile app is coming soon. For now, visit breadhq.com on a computer.
    </span>
  );
}
